import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import type { FC } from "react";
import { MAGIC_TYPE_ENUM } from "../../utils/constants";
import { AutoCompareSlider } from "./AutoCompareSlider";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

type MagicImgExampleType = {
  btnLabel: string;
  fileURIs: string[][];
  disabled: boolean;
  type: MAGIC_TYPE_ENUM;
};

type MainFunctionsProps = {
  examples: MagicImgExampleType[];
  onBtnClick: (type: MAGIC_TYPE_ENUM) => void;
};

export const MainFunctions: FC<MainFunctionsProps> = (props) => {
  // responsive UI
  const theme = useTheme();
  const notPhone = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Grid size={{ xs: 12, sm: 8 }} paddingTop={notPhone ? "100px" : "24px"}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "5px",
          padding: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <TipsAndUpdatesIcon
            color="secondary"
            sx={{ width: "18px", height: "18px" }}
          />
          <Typography
            variant="h5"
            color="secondary"
            fontStyle="italic"
            align="center"
            fontWeight={700}
          >
            选择、体验自由定制特色魔法：
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: notPhone ? "row" : "column",
            justifyContent: "center",
            gap: notPhone ? "24px" : "48px",
            padding: "16px 0",
          }}
        >
          {props.examples.map((item) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
              }}
            >
              {item.type === MAGIC_TYPE_ENUM.video && (
                <Box
                  sx={{
                    width: `200px`,
                    height: notPhone ? `180px` : "120px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <video
                    src={item.fileURIs[1][1]}
                    style={{
                      width: "100%",
                      border: `1px solid ${theme.palette.secondary.dark}`,
                      boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
                      borderRadius: "5px",
                    }}
                    controls
                    muted
                    loop
                    autoPlay
                  />
                </Box>
              )}

              {item.type !== MAGIC_TYPE_ENUM.video && (
                <AutoCompareSlider
                  img1Src={item.fileURIs[0][0]}
                  img2Src={item.fileURIs[0][1]}
                />
              )}

              <Button
                variant="contained"
                onClick={() => props.onBtnClick(item.type)}
                disabled={item.disabled}
                sx={{
                  fontSize: "16px",
                  fontWeight: 800,
                  boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
                  minWidth: "120px",
                }}
                size="small"
              >
                {item.btnLabel}
              </Button>
            </Box>
          ))}
        </Box>
      </Box>
    </Grid>
  );
};
